import { useShallow } from "zustand/react/shallow";
import { useAuthStore } from "../stores/auth.store";

export function useAuth() {
  return useAuthStore(
    useShallow((s) => ({
      user: s.user,
      isAuthenticated: s.isAuthenticated,
      isInitialized: s.isInitialized,
      isLoading: s.isLoading,
      error: s.error,
      isAdmin: s.user?.role === "admin",
      initialize: s.initialize,
      login: s.login,
      loginWithMagicLink: s.loginWithMagicLink,
      setPasswordFromInvitation: s.setPasswordFromInvitation,
      logout: s.logout,
      refreshToken: s.refreshToken,
      setUserFromToken: s.setUserFromToken,
      clearError: s.clearError,
    })),
  );
}
